export const CONTENT = {
    WELCOME: 'Welcome to Blue Shield of California CS Admin',
    USER_ID: 'User ID:',
    USER_ID_HINT: 'Your username is the same as your computer login id,e.g. JSmith0',
    PASSWORD: 'Password:',
    PASSWORD_HINT: ' Your password is the same password you use to login to your computer',
    HINT_MSG1: ' If you do not have a CS Admin user ID and password or forgot your user ID and/or password please contact your administrator/manager for assistance.',
    HINT_MSG2: 'Do not attempt to log in unless you are an authorized user. Unauthorized use of this application could be considered criminal activity and maybe punishable by law.',
    LOGIN_TITLE: 'Blue Shield CA - Customer Service Administration',
    SESSION_TIMEOUT_TITLE: 'Extend your Session',
    SESSION_TIMEOUT_CONTENT: ': your login session will expire in 3 minutes.',
    SESSION_TIMEOUT_SUB_CONTENT: 'Click ok to extend your session and continue working.',
};